import styled from "styled-components";
import Wrapper from "../DeclineRouter.styles";
import { size } from "styled-theme";

export const DeclineWrapper = styled(Wrapper)`
  @media only screen and (min-width: ${size("M")}) {
    .center-full {
      margin-top: 85px;
      margin-bottom: 80px;
    }
  }
`;